import { ChangeDetectionStrategy, Component, computed, effect, inject, input, untracked, viewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { InsightsAuthService } from '@core/services/insights-auth.service';
import { MarkdownPipe } from '@shared/pipes/markdown.pipe';
import { InsightsApiService } from './insights-api.service';
import { InsightsAccessBannerComponent } from './insights-access-banner.component';
import { InsightsStore } from './insights.store';
import { InsightsAssessmentContext } from './models/insights.model';

@Component({
  selector: 'app-insights-panel',
  imports: [MatButtonModule, MatExpansionModule, MatIconModule, MatProgressSpinnerModule, MarkdownPipe, InsightsAccessBannerComponent],
  providers: [InsightsStore, InsightsApiService],
  templateUrl: './insights-panel.component.html',
  styleUrl: './insights-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsightsPanelComponent {
  readonly context = input.required<InsightsAssessmentContext>();
  readonly autoGenerate = input(false);
  readonly manualGenerationAllowed = input(false);

  readonly store = inject(InsightsStore);
  readonly showManualGeneration = computed(() => this.manualGenerationAllowed() && this.store.manualGenerationAvailable());

  private readonly insightsAuth = inject(InsightsAuthService);

  readonly authPending = this.insightsAuth.authPending;

  readonly panel = viewChild<MatExpansionPanel>('insightsPanel');

  private lastAssessmentId: string | null = null;

  constructor() {
    effect(() => {
      const ctx = this.context();
      if (ctx && ctx.assessmentId !== this.lastAssessmentId) {
        this.lastAssessmentId = ctx.assessmentId;
        this.store.load(
          ctx,
          untracked(() => this.autoGenerate())
        );
      }
    });
  }

  generateInsights(): void {
    this.store.generateInsights();
  }
}
